import { Route, Routes } from 'react-router-dom'
import NotFound from '../../components/NotFound'
import ViteArchivioCreate from './ViteArchivioCreate'
import ViteArchivioEdit from './ViteArchivioEdit'
import ViteArchivioList from './ViteArchivioList'

export default function ViteArchivio() {
  return (
    <Routes>
      <Route index element={<ViteArchivioList />} />
      <Route path="new" element={<ViteArchivioCreate />} />
      <Route path=":id" element={<ViteArchivioEdit />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
